import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/elder-care/residents.$id";

export const Route = createFileRoute(
  "/admin/_modules/_elder-care/residents/$id"
)({
  component: Page,
});
